import { useEffect, useRef, useState } from 'react';
import { api } from '../../lib/api';

export default function useCantinaProducts(onAdd) {
  const inputRef = useRef(null);

  const [busqueda, setBusqueda] = useState('');
  const [resultados, setResultados] = useState([]);
  const [seleccion, setSeleccion] = useState(0);
  const [cargando, setCargando] = useState(false);

  const focusSearch = () => {
    requestAnimationFrame(() => {
      inputRef.current?.focus();
    });
  };

  useEffect(() => {
    focusSearch();
  }, []);

  useEffect(() => {
    const q = busqueda.trim();

    if (!q) {
      setResultados([]);
      setSeleccion(0);
      return undefined;
    }

    const timer = setTimeout(async () => {
      try {
        setCargando(true);

        const response = await api.get('/cantina/productos', {
          params: { q },
        });

        setResultados(
          Array.isArray(response.data) ? response.data : []
        );
        setSeleccion(0);
      } catch (error) {
        console.error('Error buscando productos de Cantina:', error);
        setResultados([]);
      } finally {
        setCargando(false);
      }
    }, 120);

    return () => clearTimeout(timer);
  }, [busqueda]);

  const limpiarBusqueda = () => {
    setBusqueda('');
    setResultados([]);
    setSeleccion(0);
    focusSearch();
  };

  const agregarSeleccionado = (producto) => {
    if (!producto) return;

    onAdd(producto);
    limpiarBusqueda();
  };

  const onKeyDown = (event) => {
    if (event.key === 'ArrowDown' && resultados.length) {
      event.preventDefault();
      setSeleccion((actual) =>
        Math.min(actual + 1, resultados.length - 1)
      );
      return;
    }

    if (event.key === 'ArrowUp' && resultados.length) {
      event.preventDefault();
      setSeleccion((actual) => Math.max(actual - 1, 0));
      return;
    }

    if (event.key === 'Enter' && resultados.length) {
      event.preventDefault();
      agregarSeleccionado(resultados[seleccion]);
      return;
    }

    if (event.key === 'Escape') {
      event.preventDefault();
      limpiarBusqueda();
    }
  };

  return {
    inputRef,
    busqueda,
    setBusqueda,
    resultados,
    seleccion,
    cargando,
    onKeyDown,
    agregarSeleccionado,
    limpiarBusqueda,
    focusSearch,
  };
}
